export default __webpack_public_path__ + "assets/front/scss/affichage-table.23b175a420f703fcfc84874675b98164.css";